/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RentType } from './rentType.model';
import { SubjectContactEntity } from './subjectContactEntity.model';
import { SubstateFlagType } from './substateFlagType.model';
import { ContractParamTemplate } from './contractParamTemplate.model';
import { ValorizationType } from './valorizationType.model';
import { DocumentTemplate } from './documentTemplate.model';
import { VersionType } from './versionType.model';


export interface Contract { 
    appendixNumber?: number;
    appendixNumberMax?: number;
    appendixSourceId?: number;
    autoProlongationMonths: number;
    autoProlongationMonthsUnit?: string;
    autoProlongationRepeatedly: boolean;
    contractNumber?: number;
    contractNumberCustom?: string;
    contractNumberFormat: string;
    contractNumberOfficial?: string;
    contractYear?: number;
    counterpartyNumber?: string;
    createIndividualDocuments: boolean;
    documentNote?: string;
    documentTemplate: DocumentTemplate;
    durationMonths: number;
    durationMonthsUnit?: string;
    durationToDate?: string;
    endDate?: string;
    endDateComputed?: string;
    endType?: string;
    expirationDate?: string;
    extended: boolean;
    firstNoticeAfterMonths: number;
    firstNoticeAfterMonthsUnit?: string;
    furtherRentPossible: boolean;
    id?: number;
    imported: boolean;
    indefinite: boolean;
    inflationLimit?: number | null;
    isWatched: boolean;
    lastNoticeBeforeMonths: number;
    lastNoticeBeforeMonthsUnit?: string;
    lvFullInfo?: string;
    note?: string;
    noticeDate?: string;
    noticePeriodMonths: number;
    noticePeriodMonthsUnit?: string;
    owners?: Array<SubjectContactEntity>;
    paramTemplate: ContractParamTemplate;
    payTaxOwner: boolean | null;
    paymentInKind?: boolean;
    paymentsFromEconomicYear?: boolean;
    payoutTo?: SubjectContactEntity;
    priceContract: number;
    priceContractComputed?: number;
    priceDeal?: number;
    priceDealPercentageValorization?: number | null;
    priceDealValorization?: number | null;
    rentType: RentType;
    reqNewAppendixAfterReprice: boolean;
    resignDate?: string;
    reusedPreviousExpiration: boolean;
    revisionId?: number;
    sentForSignature: boolean;
    signatureDate: string;
    signingProcess: boolean;
    state?: string;
    stateOrder?: number;
    subcontract: boolean;
    subjectOrderName?: string;
    substateFlag?: SubstateFlagType;
    successiveNextId?: number;
    successiveNumber?: number;
    successiveSourceId?: number;
    taxConcerned: boolean;
    taxOwner: number;
    taxOwnerComputed?: number;
    taxOwnerTo?: SubjectContactEntity;
    taxTenant: number;
    taxTenantComputed?: number;
    tenantHasPreemption: boolean;
    tenants?: Array<SubjectContactEntity>;
    toEconomicYear: boolean;
    useRentDrupoz: boolean;
    validity: string;
    validityExplanation?: string;
    valorizationType: ValorizationType;
    valorizeOrInflateToDate?: string | null;
    versionType: VersionType;
    watchReason?: string;
}
export namespace Contract {
}


